import { useState } from 'react';
import { shallow } from 'zustand/shallow';

import PopFilterButton from '../PopFilterButton';
import { useDiscoverStore } from '../../../../../../zustand-stores';
import PlayWithFriendsModal from './PlayWithFriendsModal';

const PlayWithFriendsPopFilter = () => {
  const { minimumMen, minimumWomen, minimumNonBinary } = useDiscoverStore(
    store => ({
      minimumMen: store.filters.minimumMen,
      minimumWomen: store.filters.minimumWomen,
      minimumNonBinary: store.filters.minimumNonBinary,
    }),
    shallow
  );

  const [modalVisible, setModalVisible] = useState(false);

  const handlePress = () => setModalVisible(prev => !prev);

  const isActive = !!(minimumMen || minimumWomen || minimumNonBinary || modalVisible);

  return (
    <>
      <PopFilterButton pressed={isActive} label="Play with Friends" onPress={handlePress} />
      <PlayWithFriendsModal visible={modalVisible} onClose={handlePress} />
    </>
  );
};

export default PlayWithFriendsPopFilter;
